import styled from 'styled-components';
import {
  trustYouGood,
  trustYouExcellent,
  trustYouVeryGood,
  trustYouFair,
  trustYouPoor,
} from '../../../../../styles/colors';
import { LI_HEIGHT } from '../../../../../styles/constants';

export const RatingStyled = styled.div`
  &.filter-rating-label-excellent,
  &.filter-rating-label-verygood,
  &.filter-rating-label-good,
  &.filter-rating-label-pleasant,
  &.filter-rating-label-poor {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: ${LI_HEIGHT};
    line-height: 24px;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 24px;
      width: 44px;
      border-radius: 4px;
      margin-right: 8px;

      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      text-align: center;
      color: white;
    }
  }

  #container_full_width & {
    div {
      display: none;
    }
  }

  &.filter-rating-label-excellent div {
    background-color: ${trustYouExcellent};
  }

  &.filter-rating-label-verygood div {
    background-color: ${trustYouVeryGood};
  }

  &.filter-rating-label-good div {
    background-color: ${trustYouGood};
  }

  &.filter-rating-label-pleasant div {
    background-color: ${trustYouFair};
  }

  &.filter-rating-label-poor div {
    background-color: ${trustYouPoor};
  }
`;
